export enum RegexType {
	DECIMAL = '^(\\d+(\\.\\d{0,2})?|\\.?\\d{1,2})$',
	NUMERIC = '^[0-9]+$',
	EMAIL = `^\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$`,
	PHONE_NUMBER = '^[\\-\\+\\(\\)\\d ]+$'
}
